module.exports = __webpack_public_path__ + "img/ch82.3d938cf9.jpg";